import React from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import {
  dinersClub,
  maestro,
  mastercard,
  visa,
} from "../../../../assets/bankCards/bankCardsIcons";
import {cookiesOpenSettings} from "../../../../actions/cookies/actions";
import {useTranslation} from "react-i18next";
import {FOOTER} from "../../../../locales/components/namespaces";
import {useDispatch} from "react-redux";

const FooterBottomSection = ({ footerLinks }) => {
    const { t } = useTranslation(FOOTER);
    const dispatch = useDispatch();
  const paymentLogos = [visa, mastercard, maestro, dinersClub];

  return (
    <Box sx={{ width: "100%" }}>
      {/* Payment Logos */}
      <Stack
        direction="row"
        spacing={1}
        flexWrap="wrap"
        sx={{ rowGap: 1, mb: 1.5 }}
      >
        {paymentLogos.map((logo, idx) => (
          <Box
            key={idx}
            sx={{
              width: { xs: 32, md: 35 },
              height: { xs: 22, md: 24 },
              bgcolor: "#FFFFFF",
              borderRadius: "4px",
              border: "1px solid #CCCCCC",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 0.5,
            }}
          >
            <img
              src={logo}
              alt="payment"
              style={{ maxHeight: "100%", maxWidth: "100%" }}
            />
          </Box>
        ))}
      </Stack>

      {/* Legal Links + Web Design Credit */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
          justifyContent: { xs: "flex-start", md: "space-between" },
          gap: { xs: 1, md: 1 },
          width: "100%",
        }}
      >
        {/* Legal Links */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            rowGap: 0.75,
            maxWidth: { xs: "100%", md: "50%" },
          }}
        >
            {footerLinks.map((link, idx) => {
                const isCookies = link === t("cookies");

                return (
                    <Typography
                        key={idx}
                        variant="body2"
                        sx={{
                            fontSize: { xs: 11, md: 12 },
                            fontFamily: "'Roboto Condensed', Arial, sans-serif",
                            fontWeight: 400,
                            lineHeight: "120%",
                            color: "#666666",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            "&:hover": { textDecoration: "underline" },
                        }}
                        // onClick={
                        //     isCookies
                        //         ? () => dispatch(cookiesOpenSettings())
                        //         : undefined
                        // }
                    >
                        <Link
                            href={isCookies ? undefined : "#"}
                            onClick={(e) => {
                                if (!isCookies) return;
                                e.preventDefault();
                                e.stopPropagation();
                                dispatch(cookiesOpenSettings());
                            }}
                            sx={{
                                color: "#666666",
                                textDecoration: "none",
                                "&:hover": { textDecoration: "underline" },
                            }}
                        >
                            {link}
                        </Link>
                    </Typography>
                );
            })}
        </Box>

        {/* Web Design Credit */}
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: 11, md: 12 },
            color: "#666666",
            whiteSpace: "nowrap",
            fontWeight: 400,
            lineHeight: "120%",
            letterSpacing: "0",
            fontFamily: "'Roboto Condensed', Arial, sans-serif",
            mt: { xs: 1, md: 0 },
            textAlign: "right",
          }}
        >
          Web Design by Big Horror
        </Typography>
      </Box>
    </Box>
  );
};

export default FooterBottomSection;
